/*
 * Purpose: Application version SSOT — synced with package.json + VERSION file
 * Last modified: 2026-06-28 | Agent
 * Completeness: 98
 */
import pkg from '../../package.json';
import { COMPANY_INFO } from '@/lib/companyInfo';

/** Semver — bump in package.json and VERSION together */
export const APP_VERSION = pkg.version;

export const APP_VERSION_LABEL = `v${APP_VERSION}`;

/** Release channel shown in UI (stable | preview | dev) */
export const RELEASE_CHANNEL =
  (import.meta.env.VITE_RELEASE_CHANNEL as string | undefined)?.trim() || 'stable';

export const VERSION_DISPLAY = `${APP_VERSION_LABEL}${RELEASE_CHANNEL !== 'stable' ? ` (${RELEASE_CHANNEL})` : ''}`;

export const BUILD_INFO = {
  version: APP_VERSION,
  channel: RELEASE_CHANNEL,
  product: COMPANY_INFO.productName,
  docsVersioning: '/docs/16-versioning.md',
} as const;
